<template>
  <div class="container">
    <div class="main-content">
      <!-- 顶部用户信息 -->
      <div class="user-container">
        <div class="uname">
          <span>{{userInfo.username}}</span>
        </div>
        <img class="touxiang" src="https://777-wx-res.oss-cn-beijing.aliyuncs.com/word_test/cpsj_touxiang@2x.png"/>
        <img class="icon-win" src="https://777-wx-res.oss-cn-beijing.aliyuncs.com/word_test/icon_cpsj_huanguan@2x.png"/>
        <img class="test-status" src="https://777-wx-res.oss-cn-beijing.aliyuncs.com/word_test/icon_cesj_wc@2x.png"/>
      </div>

      <!-- 分数 -->
      <div class="hint-score">Score</div>
      <div class="user-score">{{reporObj.score}}</div>
      <img class="score-line" src="https://777-wx-res.oss-cn-beijing.aliyuncs.com/word_test/xiahua.png" alt=""/>


      <!-- 查看排名 -->
      <div class="rank-container" @click="gotobankList">
        <img class="icon-rank" src="https://777-wx-res.oss-cn-beijing.aliyuncs.com/word_test/icon_cpsj_bangdan@2x.png"/>
        <div class="rank-title">查看大赛榜单</div>
        <img class="icon-arrow" src="https://777-wx-res.oss-cn-beijing.aliyuncs.com/word_test/btn_cpsj_jiantou@2x.png"/>
      </div>

      <!-- 个数 -->
      <div class="data-container">
        <img class="icon-data" src="https://777-wx-res.oss-cn-beijing.aliyuncs.com/word_test/icon_cpsj_gong.png"/>
        <div class="data-num">{{reporObj.all_count}}</div>
        <img class="icon-data" src="https://777-wx-res.oss-cn-beijing.aliyuncs.com/word_test/icon_cpsj_dui.png"/>
        <div class="data-num">{{reporObj.success_count}}</div>
      </div>

      <!-- 正确率 -->
      <div :class="[(isPass==0) ?'rate-container-fail': 'rate-container']">
        <div class="hint-rate">正确率</div>
        <div class="row-container">
          <div :class="[(isPass==0) ? 'actual-rate-fail' :'actual-rate']">{{reporObj.score}}</div>
          <div :class="[(isPass==0) ? 'rate-symbol-fail' :'rate-symbol']">%</div>
        </div>
      </div>
    </div>
    <div class="back_btn" @click="backRoute">
      <img src="https://777-wx-res.oss-cn-beijing.aliyuncs.com/2023_06_back.png" alt="">
    </div>
  </div>
</template>
<style lang="less" scoped>

.container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  background-size: 100% 100%;
  background-image: url("https://777-wx-res.oss-cn-beijing.aliyuncs.com/word_test/bg_cp.png");
  height: 100%;
  width: 100%;
}

.main-content {
  width: 480px;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-repeat: no-repeat;
  background-size: 480px auto;
  background-image: url("https://777-wx-res.oss-cn-beijing.aliyuncs.com/word_test/bg_cepinshuju_jianban.png");
  margin-top: 15px;
  margin-left: 14px;
}

/* 顶部用户信息 */
.user-container {
  width: 686px;
  height: 20vh;
  /* height: 232px; */
  position: relative;
  margin-top: 2vh;
}

.uname {
  width: 170px;
  height: 60px;
  color: #3E3E3E;
  background: #FFF5DA;
  border-radius: 36px 26px 26px 36px;
  font-size: 14px;
  font-weight: normal;
  line-height: 60px;
  position: absolute;
  left: 206px;
  top: 67px;
  text-align: center;
  padding-left: 30px;
}

.touxiang {
  width: 100px;
  position: absolute;
  left: 157px;
  top: 32px;
}

.icon-win {
  width: 83px;
  position: absolute;
  left: 312px;
  top: 23px;
}

.test-status {
  width: 142px;
  position: absolute;
  left: 389px;
  top: 32px;
}


.hint-score {
  height: 30px;
  font-size: 20px;
  color: #E60000;
  font-weight: bold;
  line-height: 30px;
}

.user-score {
  color: #E60000;
  height: 100px;
  font-size: 100px;
  line-height: 100px;
  text-align: center;
}

.score-line {
  width: 200px;
}

/* 排名 */
.rank-container {
  width: 350px;
  height: 55px;
  background: linear-gradient(142deg, #4BC666 0%, #66D3A2 100%);
  box-shadow: 0px 2px 12px 0px rgba(221, 221, 221, 0.5);
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin-top: 15px;
  margin-left: -9px;
}

.icon-rank {
  width: 42px;
  height: 36px;
  margin-left: 32px;
}

.rank-title {
  width: 380px;
  height: 40px;
  font-size: 20px;
  color: #FFFFFF;
  line-height: 40px;
  text-align: left;
  margin-left: 22px;

}

.icon-arrow {
  width: 27px;
  margin-right: 30px;
}

/* 总数正确数 */
.data-container {
  height: 5vh;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 2vh;
  margin-left: -48px;
}

.icon-data {
  width: 45px;
  margin-left: 48px;
}

.data-num {
  height: 60px;
  font-size: 32px;
  color: #606060;
  line-height: 60px;
  text-align: center;
  margin-left: 10px;
}

/* 正确率 */
.rate-container,
.rate-container-fail {
  width: 165px;
  height: 165px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-repeat: no-repeat;
  background-size: 165px 165px;
  background-image: url("https://777-wx-res.oss-cn-beijing.aliyuncs.com/word_test/icon_huan_jige.png");
  margin-top: 2rem;
}

.rate-container-fail {
  background-size: 165px 165px;
  background-image: url("https://777-wx-res.oss-cn-beijing.aliyuncs.com/word_test/icon_huan_bujige.png");
}

.hint-rate {
  font-size: 20px;
  color: #606060;
  margin-top: 9px;
}

.row-container {
  display: flex;
  flex-direction: row;
  align-items: baseline;
}

.actual-rate,
.actual-rate-fail,
.rate-symbol {
  font-size: 50px;
  font-weight: 600;
  color: #22CD69;
  line-height: 70px;
}

.rate-symbol {
  font-size: 36px;
  color: #22CD69;
}

.actual-rate-fail {
  color: #E97D01;
}

.rate-symbol-fail {
  font-size: 36px;
  color: #E97D01;
}

.back_btn{
  position: fixed;
  left: 3rem;
  bottom: 2rem;
}

</style>
<script>
import { mapState, mapMutations } from 'vuex'
import {test_online_report } from '../../services'

export default {
  name: 'word_competition_result',
  components: {},
  data () {
    return {
      imageurl: 'https://777-wx-res.oss-cn-beijing.aliyuncs.com/',
      isPass: 1,  //0不及格60以下， 1及格
      from_channel: 0, //从测评主界面进值为0   列表及其他为1
      reporObj: {}, //测评报告
      id: '', //测评id
      succesRate: '', //正确率
      userName: '智学树',
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo
    })
  },
  created () {
    this.id = this.$route.query.id
    test_online_report({
      id: this.id,
    }).then((res) => {
      let successRate = (res.data.success_rate * 100).toFixed();
      let isPass = this.isPass;
      if (successRate < 60) {
        isPass = 0;
      } else {
        isPass = 1;
      }
      this.reporObj=res.data;
      this.succesRate= successRate;
      this.isPass=isPass;
    })
  },
  methods:{
    backRoute:function () {
      this.$router.push({
        path: '/word_competition',
      })
    },
    gotobankList:function (){
      this.$router.push({
        path: '/word_competition_ranking',
        query: {
          id: this.id,
        }
      })
    }
  },
}
</script>
